import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { taxApi } from "../../../assets/apis";
import toast from "react-hot-toast";
import {
  setSiderBarActiveLink,
  setSiderBarActiveList,
} from "../../../redux-store/sidebarActiveList";
import { useDispatch } from "react-redux";

const AddTax = () => {
  const [addTaxData, setAddTaxData] = useState({ active: true });
  const [apiInProccess, setApiInProccess] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAddTaxData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangeWithCondition = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setAddTaxData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputChangeWithConditonTypeNumber = (e, validationRegex) => {
    const { name, value } = e.target;
    if (value === "" || validationRegex.test(value)) {
      setAddTaxData((prev) => ({ ...prev, [name]: Number(value) }));
    }
  };
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axios.post(taxApi, data);
    },
    onSuccess: () => {
      setApiInProccess(false)
      queryClient.invalidateQueries(["tax"]);
      toast.success("Tax saved successfully!");
      navigate("/tax");
    },
    onError: (error) => {
      setApiInProccess(false)
      const errorMessage = error.response?.data?.message;
      toast.error(` ${errorMessage}`);
    },
  });

  const handleSaveTax = (e) => {
    e.preventDefault();
    const { name, rate, description } = addTaxData;
    const updatedTaxData = {
      ...addTaxData,
      name: name.trim(),
      ...(description && { description: description.trim() }),
    };
    setAddTaxData(updatedTaxData);
    if (!updatedTaxData.name) return toast.error("Please enter a name");
    if (+rate > 100) return toast.error("Please enter a valid rate");
    setApiInProccess(true)
    mutation.mutate(updatedTaxData);
  };

  useEffect(() => {
    dispatch(setSiderBarActiveList({ name: "Taxes" }));
    dispatch(setSiderBarActiveLink({ link: "tax" }));
  }, []);

  return (
    <div className={`main-panel`}>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between m-1 p-1 align-items-baseline ">
              <h3 className="ukhd mb-3">Add Tax</h3>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => navigate("/tax")}
              >
                <div className="d-flex justify-content-center">
                  <i className="mdi mdi mdi-keyboard-backspace"></i>
                  <span>Back</span>
                </div>
              </button>
            </div>
            <div className="row flex-grow">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card card-rounded">
                  <div className="card-body">
                    <div className="col-lg-12">
                      <div className="col-lg-12 ">
                        <h5>TAX INFORMATION</h5>
                      </div>
                      <form onSubmit={handleSaveTax}>
                        <div className="row">
                          <div className="col-lg-4 mt-4">
                            <label>Name *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Tax"
                              required
                              name="name"
                              value={addTaxData.name || ""}
                              onChange={(e) => {
                                handleInputChangeWithCondition(
                                  e,
                                  /^[\s\S]*$/
                                );
                              }}
                            />
                          </div>
                          <div className="col-lg-4 mt-4">
                            <label>Tax (%) *</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Percentage"
                              required
                              name="rate"
                              minLength={1}
                              maxLength={3}
                              value={addTaxData.rate || ""}
                              onChange={(e) =>
                                handleInputChangeWithConditonTypeNumber(
                                  e,
                                  /^[0-9\b]+$/
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 mt-4">
                          <label>Active ? </label>{" "}
                          <input
                            type="checkbox"
                            name="active"
                            checked={addTaxData.active || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-4">
                          <label
                            className="form-control-label"
                            htmlFor="input-address"
                          >
                            Description
                          </label>
                          <textarea
                            className="form-control form-control-alternative"
                            rows="7"
                            style={{
                              borderRadius: "5px",
                              resize: "none",
                              minHeight: "80px",
                            }}
                            name="description"
                            value={addTaxData.description || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-9 mt-2">
                          <button
                            type="submit"
                            className="btn btn-primary d-flex justify-content-center px-3 py-2"
                            disabled={apiInProccess}
                          >
                            <i className="mdi mdi-content-save me-1"></i> Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTax;
